import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../../contexts/ThemeContext';

const scrollToSection = (sectionId) => {
  document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
};

const Hero = () => {
  const { themeConfig } = useTheme();
  const { hero } = themeConfig;

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(45,31,23,0.42),rgba(45,31,23,0.3)),url('${hero.backgroundImage}')`,
        }}
      />
      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="mb-8"
        >
          <p className="uppercase tracking-[0.35em] text-white/85 text-sm mb-5">
            La Vie Saigon
          </p>
          <h1 className="text-5xl md:text-7xl font-playfair text-white mb-4 leading-tight">
            {hero.title}
          </h1>
          <p className="text-2xl md:text-3xl font-playfair text-white mb-2">
            {hero.subtitle}
          </p>
          <p className="text-lg md:text-xl text-white/90 font-light">
            {hero.description}
          </p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="flex flex-col sm:flex-row gap-4 justify-center"
        >
          <button
            type="button"
            onClick={() => scrollToSection('story')}
            className="bg-warm-brown text-cream px-8 py-4 rounded-full text-lg font-medium hover:bg-warm-brown/90 transition-colors duration-300 shadow-lg"
          >
            Our Story
          </button>
          <button
            type="button"
            onClick={() => scrollToSection('contact')}
            className="border-2 border-white text-white px-8 py-4 rounded-full text-lg font-medium hover:bg-white hover:text-warm-brown transition-colors duration-300"
          >
            Visit Us
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;